function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-organization"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "organization",
  clipPath: "url(#clip-organization)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nav_Menu_Small",
  "data-name": "Nav/Menu/Small",
  transform: "translate(-27 -15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-Org.Unit",
  transform: "translate(28 16)"
}, /*#__PURE__*/React.createElement("g", {
  id: "options-outline"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M19,15a1,1,0,0,1-.015.175,3,3,0,1,1-1.969,0A.925.925,0,0,1,17,15V12.991H12.117L12,13a.994.994,0,0,1-.123-.007H7v2a1.007,1.007,0,0,1-.015.175,3,3,0,1,1-1.969,0A.921.921,0,0,1,5,14.991v-3a1,1,0,0,1,1-1h5V7.82A3,3,0,0,1,9.042,4.493l.036-.179A3,3,0,1,1,13,7.82h0v3.171h5a1,1,0,0,1,1,1Zm-1,2.009a1,1,0,1,0,1,1A1,1,0,0,0,18,17.009ZM6,17a1,1,0,1,0,1,1A1,1,0,0,0,6,17ZM12,4a1,1,0,1,0,1,1A1,1,0,0,0,12,4Z",
  fill: "currentColor"
})))));

var SvgOrganization = function SvgOrganization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/organization.4ccf038b.svg";
export { ForwardRef as ReactComponent };